import logoGts from '../assets/logo GTS.png';
import logoHessnatur from '../assets/logo hessnature.png';
import logoMono from '../assets/logo monoquick.png';
import logoWeDress from '../assets/logo we dress.png';
import logoRevolution from '../assets/logo fashion revolution.png';
import logoCosh from '../assets/logo cosh.png';
import logoBartatex from '../assets/logo bartatex.png';
import logoWortmarke from '../assets/logo wortmarke.png';
import logoNarravero from '../assets/narravero.png';
import logoKingsAndPriests from '../assets/logo-kings-and-priests.png';
import logoEbay from '../assets/ebay.png';
import logoCounsil from '../assets/fashion-counsil.png';
import logoIgedo from '../assets/igedo.png';
import logoHeartPiece from '../assets/logo heart piece.png';
import logoWildling from '../assets/logo-wildling.svg';
import logoTchibo from '../assets/logo-tchibo.svg';

export const brandsLogos = [
  {
    img: logoIgedo,
    width: '200px',
  },
  {
    img: logoWortmarke,
    width: '200px',
  },
  {
    img: logoGts,
    width: '200px',
  },
  {
    img: logoWildling,
    width: '200px',
  },
  {
    img: logoTchibo,
    width: '169px',
  },
  {
    img: logoHessnatur,
    width: '200px',
  },
  {
    img: logoMono,
    width: '180px',
  },
  {
    img: logoWeDress,
    width: '250px',
    marginRight: '25px',
  },
  {
    img: logoEbay,
    width: '130px',
    marginRight: '25px',
  },
  {
    img: logoRevolution,
    width: '80px',
    marginRight: '25px',
  },
  {
    img: logoNarravero,
    width: '200px',
    marginRight: '25px',
  },
  {
    img: logoKingsAndPriests,
    width: '121px',
    marginRight: '25px',
  },
  {
    img: logoBartatex,
    width: '100px',
    marginRight: '25px',
  },
  {
    img: logoCounsil,
    width: '150px',
    marginRight: '25px',
  },

  {
    img: logoCosh,
    width: '100px',
  },
  {
    img: logoHeartPiece,
    width: '265px',
  },
];
